module.exports = __webpack_public_path__ + "static/media/add-new-competency.b87cb0c4.svg";